<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'

  import Vol04 from './Vol04.vue'
  import Jewel03 from './Jewel03.vue'
  import Promo2019Events from './Promo2019_Events.vue'
  import Promo2019Pact from './Promo2019_Pact.vue'

  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */
  /** @type {ItemInfo[]} */ const itemsV04 = Vol04.data().items
  /** @type {ItemInfo[]} */ const itemsJ03 = Jewel03.data().items
  /** @type {ItemInfo[]} */ const itemsPromo2019Events = Promo2019Events.data().items
  /** @type {ItemInfo[]} */ const itemsPromo2019Pact = Promo2019Pact.data().items

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-02-04',
        major: [
          'あんなコレクション',
          'だいあコレクション',
          '共通',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] JR8
          // ================================================================================

          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-04',
            rare        : 'JR',
            name        : 'せいぎのピンクジュエルドレス',
            imgUrl      : '/images/items/JR8-04.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 1500,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-05',
            rare        : 'JR',
            name        : 'せいぎのピンクジュエルシューズ',
            imgUrl      : '/images/items/JR8-05.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-06',
            rare        : 'JR',
            name        : 'せいぎのピンクジュエルヘアアクセ',
            imgUrl      : '/images/items/JR8-06.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-07',
            rare        : 'JR',
            name        : 'せいぎのイエロージュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fefe0a/666/?text=JR8-07',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 1500,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-08',
            rare        : 'JR',
            name        : 'せいぎのイエロージュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fefe0a/666/?text=JR8-08',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-09',
            rare        : 'JR',
            name        : 'せいぎのイエロージュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fefe0a/666/?text=JR8-09',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-10',
            rare        : 'JR',
            name        : 'せいぎのブルージュエルドレス',
            imgUrl      : '/images/items/JR8-10.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-11',
            rare        : 'JR',
            name        : 'せいぎのブルージュエルシューズ',
            imgUrl      : '/images/items/JR8-11.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-12',
            rare        : 'JR',
            name        : 'せいぎのブルージュエルヘアアクセ',
            imgUrl      : '/images/items/JR8-12.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-13',
            rare        : 'JR',
            name        : 'せいぎのゴールドジュエルドレス',
            imgUrl      : '/images/items/JR8-13.png',
            kind        : 'ワンピース',
            color       : '金',
            brand       : 'DW',
            type        : 'LO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-14',
            rare        : 'JR',
            name        : 'せいぎのゴールドジュエルシューズ',
            imgUrl      : '/images/items/JR8-14.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-15',
            rare        : 'JR',
            name        : 'せいぎのゴールドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR8-15.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-16',
            rare        : 'JR',
            name        : 'せいぎのブラックジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/333/fff/?text=JR8-16',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 1500,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-17',
            rare        : 'JR',
            name        : 'せいぎのブラックジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/333/fff/?text=JR8-17',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-18',
            rare        : 'JR',
            name        : 'せいぎのブラックジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/333/fff/?text=JR8-18',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-01',
            rare        : 'JR',
            name        : 'せいぎのレッドジュエルドレス',
            imgUrl      : '/images/items/JR8-01.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-02',
            rare        : 'JR',
            name        : 'せいぎのレッドジュエルシューズ',
            imgUrl      : '/images/items/JR8-02.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-03',
            rare        : 'JR',
            name        : 'せいぎのレッドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR8-03.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-19',
            rare        : 'JR',
            name        : 'せいぎのグリーンジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/00770/fff/?text=JR8-19',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 1500,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-20',
            rare        : 'JR',
            name        : 'せいぎのグリーンジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/00770/fff/?text=JR8-20',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-21',
            rare        : 'JR',
            name        : 'せいぎのグリーンジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/00770/fff/?text=JR8-21',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-22',
            rare        : 'JR',
            name        : 'せいぎのパープルジュエルドレス',
            imgUrl      : '/images/items/JR8-22.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-23',
            rare        : 'JR',
            name        : 'せいぎのパープルジュエルシューズ',
            imgUrl      : '/images/items/JR8-23.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-24',
            rare        : 'JR',
            name        : 'せいぎのパープルジュエルヘアアクセ',
            imgUrl      : '/images/items/JR8-24.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-25',
            rare        : 'JR',
            name        : 'せいぎのホワイトジュエルドレス',
            imgUrl      : '/images/items/JR8-25.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-26',
            rare        : 'JR',
            name        : 'せいぎのホワイトジュエルシューズ',
            imgUrl      : '/images/items/JR8-26.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-27',
            rare        : 'JR',
            name        : 'せいぎのホワイトジュエルヘアアクセ',
            imgUrl      : '/images/items/JR8-27.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-28',
            rare        : 'JR',
            name        : 'せいぎのレインボージュエルドレス',
            imgUrl      : '/images/items/JR8-28.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'DW',
            type        : 'LO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-29',
            rare        : 'JR',
            name        : 'せいぎのレインボージュエルシューズ',
            imgUrl      : '/images/items/JR8-29.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'JR8-30',
            rare        : 'JR',
            name        : 'せいぎのレインボージュエルヘアアクセ',
            imgUrl      : '/images/items/JR8-30.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            rare        : 'JR',
          }),


          // [NOTE] JR9
          // ================================================================================

          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-04',
            rare        : 'JR',
            name        : 'ゆうじょうのピンクジュエルドレス',
            imgUrl      : '/images/items/JR9-04.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-05',
            rare        : 'JR',
            name        : 'ゆうじょうのピンクジュエルシューズ',
            imgUrl      : '/images/items/JR9-05.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-06',
            rare        : 'JR',
            name        : 'ゆうじょうのピンクジュエルヘアアクセ',
            imgUrl      : '/images/items/JR9-06.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-07',
            rare        : 'JR',
            name        : 'ゆうじょうのイエロージュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fefe0a/666/?text=JR9-07',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'MR',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-08',
            rare        : 'JR',
            name        : 'ゆうじょうのイエロージュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fefe0a/666/?text=JR9-08',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-09',
            rare        : 'JR',
            name        : 'ゆうじょうのイエロージュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fefe0a/666/?text=JR9-09',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-10',
            rare        : 'JR',
            name        : 'ゆうじょうのブルージュエルドレス',
            imgUrl      : '/images/items/JR9-10.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'MR',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-11',
            rare        : 'JR',
            name        : 'ゆうじょうのブルージュエルシューズ',
            imgUrl      : '/images/items/JR9-11.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-12',
            rare        : 'JR',
            name        : 'ゆうじょうのブルージュエルヘアアクセ',
            imgUrl      : '/images/items/JR9-12.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-13',
            rare        : 'JR',
            name        : 'ゆうじょうのゴールドジュエルドレス',
            imgUrl      : '/images/items/JR9-13.png',
            kind        : 'ワンピース',
            color       : '金',
            brand       : 'MR',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-14',
            rare        : 'JR',
            name        : 'ゆうじょうのゴールドジュエルシューズ',
            imgUrl      : '/images/items/JR9-14.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-15',
            rare        : 'JR',
            name        : 'ゆうじょうのゴールドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR9-15.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-16',
            rare        : 'JR',
            name        : 'ゆうじょうのブラックジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/333/fff/?text=JR9-16',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'MR',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-17',
            rare        : 'JR',
            name        : 'ゆうじょうのブラックジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/333/fff/?text=JR9-17',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-18',
            rare        : 'JR',
            name        : 'ゆうじょうのブラックジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/333/fff/?text=JR9-18',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-19',
            rare        : 'JR',
            name        : 'ゆうじょうのレッドジュエルドレス',
            imgUrl      : '/images/items/JR9-19.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'MR',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-20',
            rare        : 'JR',
            name        : 'ゆうじょうのレッドジュエルシューズ',
            imgUrl      : '/images/items/JR9-20.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-21',
            rare        : 'JR',
            name        : 'ゆうじょうのレッドジュエルヘアアクセ',
            imgUrl      : '/images/items/JR9-21.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-22',
            rare        : 'JR',
            name        : 'ゆうじょうのグリーンジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/00770/fff/?text=JR9-22',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'MR',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-23',
            rare        : 'JR',
            name        : 'ゆうじょうのグリーンジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/00770/fff/?text=JR9-23',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-24',
            rare        : 'JR',
            name        : 'ゆうじょうのグリーンジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/00770/fff/?text=JR9-24',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-25',
            rare        : 'JR',
            name        : 'ゆうじょうのパープルジュエルドレス',
            imgUrl      : '/images/items/JR9-25.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'MR',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),

          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-26',
            rare        : 'JR',
            name        : 'ゆうじょうのパープルジュエルシューズ',
            imgUrl      : '/images/items/JR9-26.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-27',
            rare        : 'JR',
            name        : 'ゆうじょうのパープルジュエルヘアアクセ',
            imgUrl      : '/images/items/JR9-27.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1  },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-28',
            rare        : 'JR',
            name        : 'ゆうじょうのホワイトジュエルドレス',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR9-28',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-29',
            rare        : 'JR',
            name        : 'ゆうじょうのホワイトジュエルシューズ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR9-29',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-30',
            rare        : 'JR',
            name        : 'ゆうじょうのホワイトジュエルヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=JR9-30',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            rare        : 'JR',
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-01',
            rare        : 'JR',
            name        : 'ゆうじょうのレインボージュエルドレス',
            imgUrl      : '/images/items/JR9-01.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 1500,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-02',
            rare        : 'JR',
            name        : 'ゆうじょうのレインボージュエルシューズ',
            imgUrl      : '/images/items/JR9-02.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'JR9-03',
            rare        : 'JR',
            name        : 'ゆうじょうのレインボージュエルヘアアクセ',
            imgUrl      : '/images/items/JR9-03.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            rare        : 'JR',
          }),


          // [NOTE] RR
          // ================================================================================

          item({
            collection  : 'あんなコレクション',
            id          : 'RR5-01',
            rare        : 'RR',
            name        : 'レインボーあかずきんトップス',
            imgUrl      : '/images/items/RR5-01.png',
            kind        : 'トップス',
            color       : '虹',
            brand       : 'DW',
            type        : 'LO',
            point       : 1000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'RR5-02',
            rare        : 'RR',
            name        : 'レインボーあかずきんスカート',
            imgUrl      : '/images/items/RR5-02.png',
            kind        : 'スカート',
            color       : '虹',
            brand       : 'DW',
            type        : 'LO',
            point       : 1000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'RR5-03',
            rare        : 'RR',
            name        : 'レインボーあかずきんシューズ',
            imgUrl      : '/images/items/RR5-03.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'RR5-04',
            rare        : 'RR',
            name        : 'レインボーあかずきんヘアアクセ',
            imgUrl      : '/images/items/RR5-04.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'RR5-05',
            rare        : 'RR',
            name        : 'レインボーダンスアンドストリートワンピ',
            imgUrl      : '/images/items/RR5-05.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'DS',
            type        : 'CO',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'RR5-06',
            rare        : 'RR',
            name        : 'レインボーダンスアンドストリートシューズ',
            imgUrl      : '/images/items/RR5-06.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'DS',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'RR5-07',
            rare        : 'RR',
            name        : 'レインボーダンスアンドストリートヘアアクセ',
            imgUrl      : '/images/items/RR5-07.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'DS',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            rare        : 'RR',
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'RR5-08',
            rare        : 'RR',
            name        : 'レインボープレシャスミューズワンピ',
            imgUrl      : '/images/items/RR5-08.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'PM',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'RR5-09',
            rare        : 'RR',
            name        : 'レインボープレシャスミューズシューズ',
            imgUrl      : '/images/items/RR5-09.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'RR5-10',
            rare        : 'RR',
            name        : 'レインボープレシャスミューズヘアアクセ',
            imgUrl      : '/images/items/RR5-10.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            rare        : 'RR',
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'RR5-11',
            rare        : 'RR',
            name        : 'レインボーおおかみトップス',
            imgUrl      : '/images/items/RR5-11.png',
            kind        : 'トップス',
            color       : '虹',
            brand       : 'RB',
            type        : 'CO',
            point       : 1000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'RR5-12',
            rare        : 'RR',
            name        : 'レインボーおおかみパンツ',
            imgUrl      : '/images/items/RR5-12.png',
            kind        : 'ボトムス',
            color       : '虹',
            brand       : 'RB',
            type        : 'CO',
            point       : 1000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'RR5-13',
            rare        : 'RR',
            name        : 'レインボーおおかみシューズ',
            imgUrl      : '/images/items/RR5-13.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'RB',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'RR5-14',
            rare        : 'RR',
            name        : 'レインボーおおかみヘアアクセ',
            imgUrl      : '/images/items/RR5-14.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'RB',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'RR5-15',
            rare        : 'RR',
            name        : 'レインボーキューティーハピネスワンピ',
            imgUrl      : '/images/items/RR5-15.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'CH',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'RR5-16',
            rare        : 'RR',
            name        : 'レインボーキューティーハピネスシューズ',
            imgUrl      : '/images/items/RR5-16.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'CH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'RR5-17',
            rare        : 'RR',
            name        : 'レインボーキューティーハピネスヘアアクセ',
            imgUrl      : '/images/items/RR5-17.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'CH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            rare        : 'RR',
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'RR5-18',
            rare        : 'RR',
            name        : 'レインボーミラクル☆キラッツワンピ',
            imgUrl      : '/images/items/RR5-18.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'SH',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'RR5-19',
            rare        : 'RR',
            name        : 'レインボーミラクル☆キラッツシューズ',
            imgUrl      : '/images/items/RR5-19.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'RR5-20',
            rare        : 'RR',
            name        : 'レインボーミラクル☆キラッツヘアアクセ',
            imgUrl      : '/images/items/RR5-20.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            rare        : 'RR',
          }),


          // [NOTE] HR
          // ================================================================================

          item({
            collection  : 'あんなコレクション',
            id          : 'J5-01',
            rare        : 'HR',
            name        : 'あかずきんトップス',
            imgUrl      : '/images/items/J5-01.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 1100,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-02',
            rare        : 'HR',
            name        : 'あかずきんスカート',
            imgUrl      : '/images/items/J5-02.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 1050,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-03',
            rare        : 'HR',
            name        : 'あかずきんシューズ',
            imgUrl      : '/images/items/J5-03.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-04',
            rare        : 'HR',
            name        : 'あかずきんヘアアクセ',
            imgUrl      : '/images/items/J5-04.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'J5-05',
            rare        : 'HR',
            name        : 'おおかみトップス',
            imgUrl      : '/images/items/J5-05.png',
            kind        : 'トップス',
            color       : '銀',
            brand       : 'RB',
            type        : 'CO',
            point       : 1050,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-06',
            rare        : 'HR',
            name        : 'おおかみパンツ',
            imgUrl      : '/images/items/J5-06.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 1100,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-07',
            rare        : 'HR',
            name        : 'おおかみシューズ',
            imgUrl      : '/images/items/J5-07.png',
            kind        : 'シューズ',
            color       : '銀',
            brand       : 'RB',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-08',
            rare        : 'HR',
            name        : 'おおかみヘアアクセ',
            imgUrl      : '/images/items/J5-08.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'J5-09',
            rare        : 'HR',
            name        : 'ホロスコープいてざワンピ',
            imgUrl      : '/images/items/J5-09.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 2000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-10',
            rare        : 'HR',
            name        : 'ホロスコープいてざシューズ',
            imgUrl      : '/images/items/J5-10.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-11',
            rare        : 'HR',
            name        : 'ホロスコープいてざヘアアクセ',
            imgUrl      : '/images/items/J5-11.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'J5-12',
            rare        : 'HR',
            name        : 'ホロスコープししざワンピ',
            imgUrl      : '/images/items/J5-12.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : 'CH',
            type        : 'LO',
            point       : 2000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-13',
            rare        : 'HR',
            name        : 'ホロスコープししざシューズ',
            imgUrl      : '/images/items/J5-13.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'CH',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-14',
            rare        : 'HR',
            name        : 'ホロスコープししざヘアアクセ',
            imgUrl      : '/images/items/J5-14.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'CH',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'J5-75',
            rare        : 'HR',
            name        : 'あかずきんブルートップス',
            imgUrl      : '/images/items/J5-75.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 1100,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-76',
            rare        : 'HR',
            name        : 'あかずきんブルースカート',
            imgUrl      : '/images/items/J5-76.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 1050,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-77',
            rare        : 'HR',
            name        : 'あかずきんブルーシューズ',
            imgUrl      : '/images/items/J5-77.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-78',
            rare        : 'HR',
            name        : 'あかずきんブルーヘアアクセ',
            imgUrl      : '/images/items/J5-78.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'J5-79',
            rare        : 'HR',
            name        : 'おおかみブルートップス',
            imgUrl      : '/images/items/J5-79.png',
            kind        : 'トップス',
            color       : '茶',
            brand       : 'RB',
            type        : 'CO',
            point       : 1050,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-80',
            rare        : 'HR',
            name        : 'おおかみブルーパンツ',
            imgUrl      : '/images/items/J5-80.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 1100,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-81',
            rare        : 'HR',
            name        : 'おおかみブルーシューズ',
            imgUrl      : '/images/items/J5-81.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'RB',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-82',
            rare        : 'HR',
            name        : 'おおかみブルーヘアアクセ',
            imgUrl      : '/images/items/J5-82.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'J5-83',
            rare        : 'HR',
            name        : 'ホロスコープやぎざワンピ',
            imgUrl      : '/images/items/J5-83.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 2000,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-84',
            rare        : 'HR',
            name        : 'ホロスコープやぎざシューズ',
            imgUrl      : '/images/items/J5-84.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-85',
            rare        : 'HR',
            name        : 'ホロスコープやぎざヘアアクセ',
            imgUrl      : '/images/items/J5-85.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            rare        : 'HR',
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'J5-86',
            rare        : 'HR',
            name        : 'ホロスコープおうしざワンピ',
            imgUrl      : '/images/items/J5-86.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 2000,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-87',
            rare        : 'HR',
            name        : 'ホロスコープおうしざシューズ',
            imgUrl      : '/images/items/J5-87.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-88',
            rare        : 'HR',
            name        : 'ホロスコープおうしざヘアアクセ',
            imgUrl      : '/images/items/J5-88.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            rare        : 'HR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'あんなコレクション',
            id          : 'J5-15',
            rare        : 'PR',
            name        : 'ポッピンキャンディトップス',
            imgUrl      : '/images/items/J5-15.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-16',
            rare        : 'PR',
            name        : 'ポッピンキャンディパンツ',
            imgUrl      : '/images/items/J5-16.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'MR',
            type        : 'PO',
            point       : 900,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-17',
            rare        : 'PR',
            name        : 'ポッピンキャンディシューズ',
            imgUrl      : '/images/items/J5-17.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-18',
            rare        : 'PR',
            name        : 'ポッピンキャンディヘアアクセ',
            imgUrl      : '/images/items/J5-18.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'J5-19',
            rare        : 'PR',
            name        : 'ルミナスプラネットブルートップス',
            imgUrl      : '/images/items/J5-19.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 900,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-20',
            rare        : 'PR',
            name        : 'ルミナスプラネットブルースカート',
            imgUrl      : '/images/items/J5-20.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-21',
            rare        : 'PR',
            name        : 'ルミナスプラネットブルーシューズ',
            imgUrl      : '/images/items/J5-21.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-22',
            rare        : 'PR',
            name        : 'ルミナスプラネットブルーヘアアクセ',
            imgUrl      : '/images/items/J5-22.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'あんなコレクション',
            id          : 'J5-23',
            rare        : 'PR',
            name        : 'ミス・ドラマティックブルートップス',
            imgUrl      : '/images/items/J5-23.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-24',
            rare        : 'PR',
            name        : 'ミス・ドラマティックブルースカート',
            imgUrl      : '/images/items/J5-24.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-25',
            rare        : 'PR',
            name        : 'ミス・ドラマティックブルーシューズ',
            imgUrl      : '/images/items/J5-25.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-26',
            rare        : 'PR',
            name        : 'ミス・ドラマティックブルーヘアアクセ',
            imgUrl      : '/images/items/J5-26.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'J5-89',
            rare        : 'PR',
            name        : 'ルミナスプラネットピンクトップス',
            imgUrl      : '/images/items/J5-89.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-90',
            rare        : 'PR',
            name        : 'ルミナスプラネットピンクスカート',
            imgUrl      : '/images/items/J5-90.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-91',
            rare        : 'PR',
            name        : 'ルミナスプラネットピンクシューズ',
            imgUrl      : '/images/items/J5-91.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-92',
            rare        : 'PR',
            name        : 'ルミナスプラネットピンクヘアアクセ',
            imgUrl      : '/images/items/J5-92.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'J5-93',
            rare        : 'PR',
            name        : 'ルミナスプラネットパープルトップス',
            imgUrl      : '/images/items/J5-93.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-94',
            rare        : 'PR',
            name        : 'ルミナスプラネットパープルスカート',
            imgUrl      : '/images/items/J5-94.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-95',
            rare        : 'PR',
            name        : 'ルミナスプラネットパープルシューズ',
            imgUrl      : '/images/items/J5-95.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 900,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-96',
            rare        : 'PR',
            name        : 'ルミナスプラネットパープルヘアアクセ',
            imgUrl      : '/images/items/J5-96.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'J5-97',
            rare        : 'PR',
            name        : 'ツインラブハートピンクトップス',
            imgUrl      : '/images/items/J5-97.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-98',
            rare        : 'PR',
            name        : 'ツインラブハートピンクスカート',
            imgUrl      : '/images/items/J5-98.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-99',
            rare        : 'PR',
            name        : 'ツインラブハートピンクシューズ',
            imgUrl      : '/images/items/J5-99.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-100',
            rare        : 'PR',
            name        : 'ツインラブハートピンクヘアアクセ',
            imgUrl      : '/images/items/J5-100.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'J5-101',
            rare        : 'PR',
            name        : 'ツインラブハートブルートップス',
            imgUrl      : '/images/items/J5-101.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-102',
            rare        : 'PR',
            name        : 'ツインラブハートブルースカート',
            imgUrl      : '/images/items/J5-102.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 900,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-103',
            rare        : 'PR',
            name        : 'ツインラブハートブルーシューズ',
            imgUrl      : '/images/items/J5-103.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-104',
            rare        : 'PR',
            name        : 'ツインラブハートブルーヘアアクセ',
            imgUrl      : '/images/items/J5-104.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] PR モーリーファンタジー限定
          // ================================================================================

          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-43',
            rare        : 'PR',
            name        : 'ツインラブハートイエロートップス',
            imgUrl      : '/images/items/MF-43.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-44',
            rare        : 'PR',
            name        : 'ツインラブハートイエローパンツ',
            imgUrl      : '/images/items/MF-44.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-45',
            rare        : 'PR',
            name        : 'ツインラブハートイエローシューズ',
            imgUrl      : '/images/items/MF-45.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-46',
            rare        : 'PR',
            name        : 'ツインラブハートイエローヘアアクセ',
            imgUrl      : '/images/items/MF-46.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'あんなコレクション',
            id          : 'J5-27',
            rare        : 'SR',
            name        : 'ヒップホップダンストップス',
            imgUrl      : '/images/items/J5-27.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-28',
            rare        : 'SR',
            name        : 'ヒップホップダンスパンツ',
            imgUrl      : '/images/items/J5-28.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-29',
            rare        : 'SR',
            name        : 'ヒップホップダンスシューズ',
            imgUrl      : '/images/items/J5-29.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'あんなコレクション',
            id          : 'J5-30',
            rare        : 'SR',
            name        : 'ヒップホップダンスヘアアクセ',
            imgUrl      : '/images/items/J5-30.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'だいあコレクション',
            id          : 'J5-105',
            rare        : 'SR',
            name        : 'ヒップホップダンスシトラストップス',
            imgUrl      : '/images/items/J5-105.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-106',
            rare        : 'SR',
            name        : 'ヒップホップダンスシトラスパンツ',
            imgUrl      : '/images/items/J5-106.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-107',
            rare        : 'SR',
            name        : 'ヒップホップダンスシトラスシューズ',
            imgUrl      : '/images/items/J5-107.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'だいあコレクション',
            id          : 'J5-108',
            rare        : 'SR',
            name        : 'ヒップホップダンスシトラスヘアアクセ',
            imgUrl      : '/images/items/J5-108.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J5-31',
            rare        : 'SR',
            name        : 'ゆめみるおとめワンピ',
            imgUrl      : '/images/items/J5-31.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-32',
            rare        : 'SR',
            name        : 'ゆめみるおとめシューズ',
            imgUrl      : '/images/items/J5-32.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-33',
            rare        : 'SR',
            name        : 'ゆめみるおとめヘアアクセ',
            imgUrl      : '/images/items/J5-33.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'SR',
          }),


          item({
            collection  : '共通',
            id          : 'J5-34',
            rare        : 'SR',
            name        : 'ウィンタードリームパレードホワイトドレス',
            imgUrl      : '/images/items/J5-34.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-35',
            rare        : 'SR',
            name        : 'ウィンタードリームパレードホワイトシューズ',
            imgUrl      : '/images/items/J5-35.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-36',
            rare        : 'SR',
            name        : 'ウィンタードリームパレードホワイトヘアアクセ',
            imgUrl      : '/images/items/J5-36.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'SR',
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'J5-38',
            rare        : 'R',
            name        : 'ロッキンパイレーツトップス',
            imgUrl      : '/images/items/J5-38.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-39',
            rare        : 'R',
            name        : 'ロッキンパイレーツスカート',
            imgUrl      : '/images/items/J5-39.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-40',
            rare        : 'R',
            name        : 'ロッキンパイレーツシューズ',
            imgUrl      : '/images/items/J5-40.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-41',
            rare        : 'R',
            name        : 'ロッキンパイレーツヘアアクセ',
            imgUrl      : '/images/items/J5-41.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J5-42',
            rare        : 'R',
            name        : 'フレンチレーストップス',
            imgUrl      : '/images/items/J5-42.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-43',
            rare        : 'R',
            name        : 'フレンチレーススカート',
            imgUrl      : '/images/items/J5-43.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-44',
            rare        : 'R',
            name        : 'フレンチレースシューズ',
            imgUrl      : '/images/items/J5-44.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-45',
            rare        : 'R',
            name        : 'フレンチレースヘアアクセ',
            imgUrl      : '/images/items/J5-45.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'J5-46',
            rare        : 'N',
            name        : 'にじのマーチトップス',
            imgUrl      : '/images/items/J5-46.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-47',
            rare        : 'N',
            name        : 'にじのマーチスカート',
            imgUrl      : '/images/items/J5-47.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-48',
            rare        : 'N',
            name        : 'にじのマーチシューズ',
            imgUrl      : '/images/items/J5-48.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-49',
            rare        : 'N',
            name        : 'にじのマーチヘアアクセ',
            imgUrl      : '/images/items/J5-49.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'J5-50',
            rare        : 'N',
            name        : 'ミステリアスローズワンピ',
            imgUrl      : '/images/items/J5-50.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-51',
            rare        : 'N',
            name        : 'ミステリアスローズシューズ',
            imgUrl      : '/images/items/J5-51.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-52',
            rare        : 'N',
            name        : 'ミステリアスローズヘアアクセ',
            imgUrl      : '/images/items/J5-52.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'N',
          }),


          item({
            collection  : '共通',
            id          : 'J5-53',
            rare        : 'N',
            name        : 'ラブリーステッチワンピ',
            imgUrl      : '/images/items/J5-53.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-54',
            rare        : 'N',
            name        : 'ラブリーステッチシューズ',
            imgUrl      : '/images/items/J5-54.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-55',
            rare        : 'N',
            name        : 'ラブリーステッチヘアアクセ',
            imgUrl      : '/images/items/J5-55.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'N',
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'J5-37',
            rare        : 'SR',
            name        : 'ブラックタピオカミルクティー',
            imgUrl      : '/images/items/J5-37.png',
            kind        : 'パシャッとアイテム',
            color       : '茶',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-56',
            rare        : 'R',
            name        : 'まほうのブルーカード',
            imgUrl      : '/images/items/J5-56.png',
            kind        : 'パシャッとアイテム',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'J5-57',
            rare        : 'R',
            name        : 'あったかビーフシチュー',
            imgUrl      : '/images/items/J5-57.png',
            kind        : 'パシャッとアイテム',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] ブランドランク
          // ================================================================================

          item({
            collection  : 'ブランドランク',
            id          : 'DW-12',
            rare        : 'SR',
            name        : 'ハート＆レースイエロートップス',
            imgUrl      : '/images/items/DW-12.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'DW-13',
            rare        : 'SR',
            name        : 'ハート＆レースイエロースカート',
            imgUrl      : '/images/items/DW-13.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'DW-14',
            rare        : 'SR',
            name        : 'ハート＆レースイエローシューズ',
            imgUrl      : '/images/items/DW-14.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ブランドランク',
            id          : 'DW-15',
            rare        : 'SR',
            name        : 'ハート＆レースイエローヘアアクセ',
            imgUrl      : '/images/items/DW-15.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プレゼントボックス
          // ================================================================================

          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-25',
            rare        : 'SR',
            name        : 'プリパラナースいのりのトップス',
            imgUrl      : '/images/items/PB-25.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : '',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-26',
            rare        : 'SR',
            name        : 'プリパラナースいのりのスカート',
            imgUrl      : '/images/items/PB-26.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : '',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-27',
            rare        : 'SR',
            name        : 'プリパラナースいのりのシューズ',
            imgUrl      : '/images/items/PB-27.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-28',
            rare        : 'SR',
            name        : 'プリパラナースいのりのヘアアクセ',
            imgUrl      : '/images/items/PB-28.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-29',
            rare        : 'SR',
            name        : 'マーチングフェザーレッドトップス',
            imgUrl      : '/images/items/PB-29.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-30',
            rare        : 'SR',
            name        : 'マーチングフェザーレッドスカート',
            imgUrl      : '/images/items/PB-30.png',
            kind        : 'スカート',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-31',
            rare        : 'SR',
            name        : 'マーチングフェザーレッドシューズ',
            imgUrl      : '/images/items/PB-31.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-32',
            rare        : 'SR',
            name        : 'マーチングフェザーレッドヘアアクセ',
            imgUrl      : '/images/items/PB-32.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-33',
            rare        : 'SR',
            name        : 'トライアングルクーレストワンピ',
            imgUrl      : '/images/items/PB-33.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-34',
            rare        : 'SR',
            name        : 'トライアングルクーレストシューズ',
            imgUrl      : '/images/items/PB-34.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-35',
            rare        : 'SR',
            name        : 'トライアングルクーレストヘアアクセ',
            imgUrl      : '/images/items/PB-35.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-35:after',
            rare        : 'SR',
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-36',
            rare        : 'SR',
            name        : 'トライアングルポップンワンピ',
            imgUrl      : '/images/items/PB-36.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-37',
            rare        : 'SR',
            name        : 'トライアングルポップンシューズ',
            imgUrl      : '/images/items/PB-37.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-38',
            rare        : 'SR',
            name        : 'トライアングルポップンヘアアクセ',
            imgUrl      : '/images/items/PB-38.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-38:after',
            rare        : 'SR',
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-39',
            rare        : 'SR',
            name        : 'トライアングルラブリー♡ワンピ',
            imgUrl      : '/images/items/PB-39.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-40',
            rare        : 'SR',
            name        : 'トライアングルラブリー♡シューズ',
            imgUrl      : '/images/items/PB-40.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-41',
            rare        : 'SR',
            name        : 'トライアングルラブリー♡ヘアアクセ',
            imgUrl      : '/images/items/PB-41.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-41:after',
            rare        : 'SR',
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-42',
            rare        : 'R',
            name        : 'サイリウムチャーム',
            imgUrl      : '/images/items/PB-42.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-42:after1',
            rare        : 'R',
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-42:after2',
            rare        : 'R',
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-42:after3',
            rare        : 'R',
          }),


          // [NOTE] ファントミラージュチャンネル
          // ================================================================================

          item({
            collection  : 'ファントミラージュチャンネル',
            id          : 'J5-61',
            rare        : 'SR',
            name        : 'ファントミクローバーヨツバワンピ',
            imgUrl      : '/images/items/J5-61.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファントミラージュチャンネル',
            id          : 'J5-62',
            rare        : 'SR',
            name        : 'ファントミクローバーヨツバシューズ',
            imgUrl      : '/images/items/J5-62.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファントミラージュチャンネル',
            id          : 'J5-63',
            rare        : 'SR',
            name        : 'ファントミクローバーヨツバヘアアクセ',
            imgUrl      : '/images/items/J5-63.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファントミラージュチャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'ファントミラージュチャンネル',
            id          : 'J5-64',
            rare        : 'SR',
            name        : 'ファントミスペードサキワンピ',
            imgUrl      : '/images/items/J5-64.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファントミラージュチャンネル',
            id          : 'J5-65',
            rare        : 'SR',
            name        : 'ファントミスペードサキシューズ',
            imgUrl      : '/images/items/J5-65.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファントミラージュチャンネル',
            id          : 'J5-66',
            rare        : 'SR',
            name        : 'ファントミスペードサキヘアアクセ',
            imgUrl      : '/images/items/J5-66.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ファントミラージュチャンネル',
            rare        : 'SR',
          }),


          // [NOTE] すみっコぐらしチャンネル
          // ================================================================================

          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'J5-58',
            rare        : 'R',
            name        : 'すみっコぐらしクリスマスワンピ',
            imgUrl      : '/images/items/J5-58.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1000,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'J5-59',
            rare        : 'R',
            name        : 'すみっコぐらしクリスマスシューズ',
            imgUrl      : '/images/items/J5-59.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'J5-60',
            rare        : 'R',
            name        : 'すみっコぐらしクリスマスヘアアクセ',
            imgUrl      : '/images/items/J5-60.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            rare        : 'R',
          }),


          externalItem(itemsV04, 'PCH4-83'),
          externalItem(itemsV04, 'PCH4-84'),
          externalItem(itemsV04, 'PCH4-85'),
          item({
            collection  : 'すみっコぐらしチャンネル',
            rare        : 'R',
          }),


          externalItem(itemsV04, 'PCH4-86'),
          externalItem(itemsV04, 'PCH4-87'),
          externalItem(itemsV04, 'PCH4-88'),
          item({
            collection  : 'すみっコぐらしチャンネル',
            rare        : 'R',
          }),


          externalItem(itemsV04, 'PCH4-89'),
          externalItem(itemsV04, 'PCH4-90'),
          externalItem(itemsV04, 'PCH4-91'),
          externalItem(itemsV04, 'PCH4-92'),


          externalItem(itemsV04, 'PCH4-93'),
          externalItem(itemsV04, 'PCH4-94'),
          item({
            collection  : 'すみっコぐらしチャンネル',
            rare        : 'R',
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            rare        : 'R',
          }),


          externalItem(itemsJ03, 'J3-111'),
          externalItem(itemsJ03, 'J3-112'),
          externalItem(itemsJ03, 'J3-113'),
          item({
            collection  : 'すみっコぐらしチャンネル',
            rare        : 'SR',
          }),


          externalItem(itemsV04, 'PCH4-82'),
          externalItem(itemsJ03, 'J3-114'),
          item({
            collection  : 'すみっコぐらしチャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] おしょうがつチャンネル
          // ================================================================================

          item({
            collection  : 'おしょうがつチャンネル',
            id          : 'J5-112',
            rare        : 'SR',
            name        : 'アジアンおしょうがつワンピ',
            imgUrl      : '/images/items/J5-112.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつチャンネル',
            id          : 'J5-113',
            rare        : 'SR',
            name        : 'アジアンおしょうがつシューズ',
            imgUrl      : '/images/items/J5-113.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつチャンネル',
            id          : 'J5-114',
            rare        : 'SR',
            name        : 'アジアンおしょうがつヘアアクセ',
            imgUrl      : '/images/items/J5-114.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつチャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'おしょうがつチャンネル',
            id          : 'J5-115',
            rare        : 'SR',
            name        : 'ちょうのまいおしょうがつトップス',
            imgUrl      : '/images/items/J5-115.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつチャンネル',
            id          : 'J5-116',
            rare        : 'SR',
            name        : 'ちょうのまいおしょうがつスカート',
            imgUrl      : '/images/items/J5-116.png',
            kind        : 'ボトムス',
            color       : '金',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつチャンネル',
            id          : 'J5-117',
            rare        : 'SR',
            name        : 'ちょうのまいおしょうがつシューズ',
            imgUrl      : '/images/items/J5-117.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつチャンネル',
            id          : 'J5-118',
            rare        : 'SR',
            name        : 'ちょうのまいおしょうがつヘアアクセ',
            imgUrl      : '/images/items/J5-118.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリティーオールフレンズチャンネル
          // ================================================================================

          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J5-01',
            rare        : 'SR',
            name        : 'プリティーオールフレンズべるトップス',
            imgUrl      : '/images/items/PAF-J5-01.png',
            kind        : '',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : '750',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J5-02',
            rare        : 'SR',
            name        : 'プリティーオールフレンズべるスカート',
            imgUrl      : '/images/items/PAF-J5-02.png',
            kind        : '',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : '700',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J5-03',
            rare        : 'SR',
            name        : 'プリティーオールフレンズべるシューズ',
            imgUrl      : '/images/items/PAF-J5-03.png',
            kind        : '',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : '650',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J5-04',
            rare        : 'SR',
            name        : 'プリティーオールフレンズべるヘアアクセ',
            imgUrl      : '/images/items/PAF-J5-04.png',
            kind        : '',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : '650',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J5-05',
            rare        : 'SR',
            name        : 'プリティーオールフレンズおとはトップス',
            imgUrl      : '/images/items/PAF-J5-05.png',
            kind        : '',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : '750',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J5-06',
            rare        : 'SR',
            name        : 'プリティーオールフレンズおとはスカート',
            imgUrl      : '/images/items/PAF-J5-06.png',
            kind        : '',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : '700',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J5-07',
            rare        : 'SR',
            name        : 'プリティーオールフレンズベルローズシューズ',
            imgUrl      : '/images/items/PAF-J5-07.png',
            kind        : '',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : '650',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J5-08',
            rare        : 'SR',
            name        : 'プリティーオールフレンズベルローズヘアアクセ',
            imgUrl      : '/images/items/PAF-J5-08.png',
            kind        : '',
            color       : '赤',
            brand       : '',
            type        : 'LO',
            point       : '650',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J5-09',
            rare        : 'SR',
            name        : 'プリティーオールフレンズわかなトップス',
            imgUrl      : '/images/items/PAF-J5-09.png',
            kind        : '',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : '750',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PAF-J5-10',
            rare        : 'SR',
            name        : 'プリティーオールフレンズわかなパンツ',
            imgUrl      : '/images/items/PAF-J5-10.png',
            kind        : '',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : '700',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            rare        : 'SR',
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            rare        : 'SR',
          }),


          // [NOTE] クーリッシュグレーコーデスペシャルキャンペーン
          // ================================================================================

          externalItem(itemsPromo2019Events, 'P-180', { collection: 'CGCSpecial' }),
          externalItem(itemsPromo2019Events, 'P-181', { collection: 'CGCSpecial' }),
          externalItem(itemsPromo2019Events, 'P-182', { collection: 'CGCSpecial' }),
          item({
            collection  : 'CGCSpecial',
            rare        : 'SR',
          }),


          // [NOTE] クリスマスチャンネル
          // ================================================================================

          item({
            collection  : 'クリスマスチャンネル',
            id          : 'J5-67',
            rare        : 'SR',
            name        : 'クリスマスキャロルレッドトップス',
            imgUrl      : '/images/items/J5-67.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'クリスマスチャンネル',
            id          : 'J5-68',
            rare        : 'SR',
            name        : 'クリスマスキャロルレッドスカート',
            imgUrl      : '/images/items/J5-68.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'クリスマスチャンネル',
            id          : 'J5-69',
            rare        : 'SR',
            name        : 'クリスマスキャロルレッドシューズ',
            imgUrl      : '/images/items/J5-69.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'クリスマスチャンネル',
            id          : 'J5-70',
            rare        : 'SR',
            name        : 'クリスマスキャロルレッドヘアアクセ',
            imgUrl      : '/images/items/J5-70.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'クリスマスチャンネル',
            id          : 'J5-71',
            rare        : 'SR',
            name        : 'スペシャルクリスマスホワイトトップス',
            imgUrl      : '/images/items/J5-71.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'クリスマスチャンネル',
            id          : 'J5-72',
            rare        : 'SR',
            name        : 'スペシャルクリスマスホワイトスカート',
            imgUrl      : '/images/items/J5-72.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'クリスマスチャンネル',
            id          : 'J5-73',
            rare        : 'SR',
            name        : 'スペシャルクリスマスホワイトシューズ',
            imgUrl      : '/images/items/J5-73.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'クリスマスチャンネル',
            id          : 'J5-74',
            rare        : 'SR',
            name        : 'スペシャルクリスマスホワイトヘアアクセ',
            imgUrl      : '/images/items/J5-74.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ウィンタースクラッチ
          // ================================================================================

          item({
            collection  : 'ウィンタースクラッチ',
            id          : 'SC5-01',
            rare        : 'R',
            name        : 'ホワイトクリスマスリースリボンワンピ',
            imgUrl      : '/images/items/SC5-01.jpg',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ウィンタースクラッチ',
            id          : 'SC5-02',
            rare        : 'R',
            name        : 'ホワイトクリスマスリースシューズ',
            imgUrl      : '/images/items/SC5-02.jpg',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ウィンタースクラッチ',
            id          : 'SC5-03',
            rare        : 'R',
            name        : 'ホワイトクリスマスヘアアクセ',
            imgUrl      : '/images/items/SC5-03.jpg',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ウィンタースクラッチ',
            rare        : 'R',
          }),


          // [NOTE] ジュエルパクト
          // ================================================================================

          externalItem(itemsPromo2019Pact, 'JP-196', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-197', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-198', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-199', { collection: 'ジュエルパクト' }),


          externalItem(itemsPromo2019Pact, 'JP-200', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-201', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-202', { collection: 'ジュエルパクト' }),
          externalItem(itemsPromo2019Pact, 'JP-203', { collection: 'ジュエルパクト' }),


          // [NOTE] 冬休み福袋その1
          // ================================================================================

          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-01',
            rare        : 'PR',
            name        : 'ゴシックフリルナイトトップス',
            imgUrl      : '/images/items/SLJ5-01.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-02',
            rare        : 'PR',
            name        : 'ゴシックフリルナイトスカート',
            imgUrl      : '/images/items/SLJ5-02.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-03',
            rare        : 'PR',
            name        : 'ゴシックフリルナイトシューズ',
            imgUrl      : '/images/items/SLJ5-03.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-04',
            rare        : 'PR',
            name        : 'ゴシックフリルナイトヘアアクセ',
            imgUrl      : '/images/items/SLJ5-04.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-05',
            rare        : 'PR',
            name        : 'チアリーダーグリーントップス',
            imgUrl      : '/images/items/SLJ5-05.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-06',
            rare        : 'PR',
            name        : 'チアリーダーグリーンスカート',
            imgUrl      : '/images/items/SLJ5-06.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-07',
            rare        : 'PR',
            name        : 'チアリーダーグリーンシューズ',
            imgUrl      : '/images/items/SLJ5-07.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-08',
            rare        : 'PR',
            name        : 'チアリーダーグリーンヘアアクセ',
            imgUrl      : '/images/items/SLJ5-08.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-09',
            rare        : 'SR',
            name        : 'ギンガムハートスカイブルートップス',
            imgUrl      : '/images/items/SLJ5-09.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-10',
            rare        : 'SR',
            name        : 'ギンガムハートスカイブルースカート',
            imgUrl      : '/images/items/SLJ5-10.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-11',
            rare        : 'SR',
            name        : 'ギンガムハートスカイブルーシューズ',
            imgUrl      : '/images/items/SLJ5-11.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-12',
            rare        : 'SR',
            name        : 'ギンガムハートスカイブルーヘアアクセ',
            imgUrl      : '/images/items/SLJ5-12.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-13',
            rare        : 'SR',
            name        : 'シルキーハートサイリウムワンピ',
            imgUrl      : '/images/items/SLJ5-13.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-14',
            rare        : 'SR',
            name        : 'シルキーハートサイリウムシューズ',
            imgUrl      : '/images/items/SLJ5-14.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-15',
            rare        : 'SR',
            name        : 'シルキーハートサイリウムヘアアクセ',
            imgUrl      : '/images/items/SLJ5-15.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            rare        : 'SR',
          }),


          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-16',
            rare        : 'SR',
            name        : 'フレッシュSoLaMiチームCワンピS',
            imgUrl      : '/images/items/SLJ5-16.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-17',
            rare        : 'SR',
            name        : 'フレッシュSoLaMiチームCシューズS',
            imgUrl      : '/images/items/SLJ5-17.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-18',
            rare        : 'SR',
            name        : 'フレッシュSoLaMiチームCヘアアクセS',
            imgUrl      : '/images/items/SLJ5-18.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            rare        : 'SR',
          }),


          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-19',
            rare        : 'SR',
            name        : 'ミュージカルフレアワンピ',
            imgUrl      : '/images/items/SLJ5-19.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-20',
            rare        : 'SR',
            name        : 'ミュージカルフレアシューズ',
            imgUrl      : '/images/items/SLJ5-20.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-21',
            rare        : 'SR',
            name        : 'ミュージックヘアアクセ',
            imgUrl      : '/images/items/SLJ5-21.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            rare        : 'SR',
          }),


          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-22',
            rare        : 'SR',
            name        : 'おえかきペイントパレットトップス',
            imgUrl      : '/images/items/SLJ5-22.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-23',
            rare        : 'SR',
            name        : 'おえかきペイントパレットスカート',
            imgUrl      : '/images/items/SLJ5-23.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-24',
            rare        : 'SR',
            name        : 'おえかきペイントパレットシューズ',
            imgUrl      : '/images/items/SLJ5-24.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-25',
            rare        : 'SR',
            name        : 'おえかきペイントパレットヘアアクセ',
            imgUrl      : '/images/items/SLJ5-25.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-26',
            rare        : 'SR',
            name        : 'ノクターンスカイアイドルシャツD',
            imgUrl      : '/images/items/SLJ5-26.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-27',
            rare        : 'SR',
            name        : 'ノクターンスカイアイドルスカートD',
            imgUrl      : '/images/items/SLJ5-27.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-28',
            rare        : 'SR',
            name        : 'ノクターンスカイアイドルブーツD',
            imgUrl      : '/images/items/SLJ5-28.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-29',
            rare        : 'SR',
            name        : 'ノクターンスカイアイドルヘアアクセD',
            imgUrl      : '/images/items/SLJ5-29.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-30',
            rare        : 'SR',
            name        : 'かれいなるジェットレッドトップス',
            imgUrl      : '/images/items/SLJ5-30.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-31',
            rare        : 'SR',
            name        : 'かれいなるジェットレッドパンツ',
            imgUrl      : '/images/items/SLJ5-31.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-32',
            rare        : 'SR',
            name        : 'かれいなるジェットレッドシューズ',
            imgUrl      : '/images/items/SLJ5-32.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-33',
            rare        : 'SR',
            name        : 'かれいなるジェットレッドヘアアクセ',
            imgUrl      : '/images/items/SLJ5-33.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-34',
            rare        : 'SR',
            name        : 'メルヘンクロックアイストップス',
            imgUrl      : '/images/items/SLJ5-34.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-35',
            rare        : 'SR',
            name        : 'メルヘンクロックアイススカート',
            imgUrl      : '/images/items/SLJ5-35.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-36',
            rare        : 'SR',
            name        : 'メルヘンクロックアイスシューズ',
            imgUrl      : '/images/items/SLJ5-36.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その1',
            id          : 'SLJ5-37',
            rare        : 'SR',
            name        : 'メルヘンクロックアイスヘアアクセ',
            imgUrl      : '/images/items/SLJ5-37.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] 冬休み福袋その2
          // ================================================================================

          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-38',
            rare        : 'PR',
            name        : 'フラワーショップブルースタートップス',
            imgUrl      : '/images/items/SLJ5-38.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-39',
            rare        : 'PR',
            name        : 'フラワーショップブルースタースカート',
            imgUrl      : '/images/items/SLJ5-39.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-40',
            rare        : 'PR',
            name        : 'フラワーショップブルースターシューズ',
            imgUrl      : '/images/items/SLJ5-40.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : '800',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-41',
            rare        : 'PR',
            name        : 'フラワーショップブルースターヘアアクセ',
            imgUrl      : '/images/items/SLJ5-41.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : '800',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-42',
            rare        : 'PR',
            name        : 'パンクキャットホワイトイエロートップス',
            imgUrl      : '/images/items/SLJ5-42.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : '900',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-43',
            rare        : 'PR',
            name        : 'パンクキャットホワイトイエロースカート',
            imgUrl      : '/images/items/SLJ5-43.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : '850',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-44',
            rare        : 'PR',
            name        : 'パンクキャットホワイトイエローシューズ',
            imgUrl      : '/images/items/SLJ5-44.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : '800',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-45',
            rare        : 'PR',
            name        : 'パンクキャットホワイトイエローヘアアクセ',
            imgUrl      : '/images/items/SLJ5-45.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : '800',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-46',
            rare        : 'SR',
            name        : 'ワイズガールレッドトップス',
            imgUrl      : '/images/items/SLJ5-46.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : '750',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-47',
            rare        : 'SR',
            name        : 'ワイズガールレッドスカート',
            imgUrl      : '/images/items/SLJ5-47.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : '700',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-48',
            rare        : 'SR',
            name        : 'ワイズガールレッドシューズ',
            imgUrl      : '/images/items/SLJ5-48.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : '650',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-49',
            rare        : 'SR',
            name        : 'ワイズガールレッドヘアアクセ',
            imgUrl      : '/images/items/SLJ5-49.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : '650',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-50',
            rare        : 'SR',
            name        : 'ベースボールゲームトップス',
            imgUrl      : '/images/items/SLJ5-50.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : '750',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-51',
            rare        : 'SR',
            name        : 'ベースボールゲームパンツ',
            imgUrl      : '/images/items/SLJ5-51.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : '700',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-52',
            rare        : 'SR',
            name        : 'ベースボールゲームシューズ',
            imgUrl      : '/images/items/SLJ5-52.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : '650',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-53',
            rare        : 'SR',
            name        : 'ベースボールゲームヘアアクセ',
            imgUrl      : '/images/items/SLJ5-53.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : '650',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-54',
            rare        : 'SR',
            name        : 'ダイヤチェックローズトップス',
            imgUrl      : '/images/items/SLJ5-54.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : '750',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-55',
            rare        : 'SR',
            name        : 'ダイヤチェックローズスカート',
            imgUrl      : '/images/items/SLJ5-55.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : '700',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-56',
            rare        : 'SR',
            name        : 'ダイヤチェックローズシューズ',
            imgUrl      : '/images/items/SLJ5-56.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : '650',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-57',
            rare        : 'SR',
            name        : 'ダイヤチェックローズヘアアクセ',
            imgUrl      : '/images/items/SLJ5-57.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : '650',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-58',
            rare        : 'SR',
            name        : 'アンティークベリートップス',
            imgUrl      : '/images/items/SLJ5-58.png',
            kind        : 'トップス',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : '750',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-59',
            rare        : 'SR',
            name        : 'アンティークベリースカート',
            imgUrl      : '/images/items/SLJ5-59.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : '700',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-60',
            rare        : 'SR',
            name        : 'アンティークベリーシューズ',
            imgUrl      : '/images/items/SLJ5-60.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : '650',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-61',
            rare        : 'SR',
            name        : 'アンティークベリーヘアアクセ',
            imgUrl      : '/images/items/SLJ5-61.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : '',
            type        : 'CO',
            point       : '650',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-62',
            rare        : 'SR',
            name        : 'ぷちゅうセレブトップス',
            imgUrl      : '/images/items/SLJ5-62.png',
            kind        : 'トップス',
            color       : '金',
            brand       : '',
            type        : 'CO',
            point       : '750',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-63',
            rare        : 'SR',
            name        : 'ぷちゅうセレブスカート',
            imgUrl      : '/images/items/SLJ5-63.png',
            kind        : 'ボトムス',
            color       : '銀',
            brand       : '',
            type        : 'CO',
            point       : '700',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-64',
            rare        : 'SR',
            name        : 'ぷちゅうセレブシューズ',
            imgUrl      : '/images/items/SLJ5-64.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : '',
            type        : 'CO',
            point       : '650',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-65',
            rare        : 'SR',
            name        : 'ぷちゅうセレブヘアアクセ',
            imgUrl      : '/images/items/SLJ5-65.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : '',
            type        : 'CO',
            point       : '650',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-66',
            rare        : 'SR',
            name        : 'スチームパンクフェザートップス',
            imgUrl      : '/images/items/SLJ5-66.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : '750',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-67',
            rare        : 'SR',
            name        : 'スチームパンクフェザースカート',
            imgUrl      : '/images/items/SLJ5-67.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : '700',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-68',
            rare        : 'SR',
            name        : 'スチームパンクフェザーシューズ',
            imgUrl      : '/images/items/SLJ5-68.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : '650',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-69',
            rare        : 'SR',
            name        : 'スチームパンクフェザーヘアアクセ',
            imgUrl      : '/images/items/SLJ5-69.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : '650',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-70',
            rare        : 'SR',
            name        : 'ベリーソースシェフトップス',
            imgUrl      : '/images/items/SLJ5-70.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '750',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-71',
            rare        : 'SR',
            name        : 'ベリーソースシェフスカート',
            imgUrl      : '/images/items/SLJ5-71.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '700',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-72',
            rare        : 'SR',
            name        : 'ベリーソースシェフシューズ',
            imgUrl      : '/images/items/SLJ5-72.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : '650',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-73',
            rare        : 'SR',
            name        : 'シェフハットヘアアクセ',
            imgUrl      : '/images/items/SLJ5-73.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : '650',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-74',
            rare        : 'SR',
            name        : 'マーチングフェザーブルートップス',
            imgUrl      : '/images/items/SLJ5-74.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : '750',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-75',
            rare        : 'SR',
            name        : 'マーチングフェザーブルースカート',
            imgUrl      : '/images/items/SLJ5-75.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : '700',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-76',
            rare        : 'SR',
            name        : 'マーチングフェザーブルーシューズ',
            imgUrl      : '/images/items/SLJ5-76.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : '650',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '冬休み福袋その2',
            id          : 'SLJ5-77',
            rare        : 'SR',
            name        : 'マーチングフェザーブルーヘアアクセ',
            imgUrl      : '/images/items/SLJ5-77.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : '650',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ニコチケ PR
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-01',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムあろまアナザーワンピ',
            imgUrl      : '/images/items/NC-J5-01.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 1600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-02',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムあろまアナザーシューズ',
            imgUrl      : '/images/items/NC-J5-02.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-J5-01',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-03',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムあろまアナザーヘアアクセ',
            imgUrl      : '/images/items/NC-J5-03.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-J5-01',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'PR',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-59',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムみかんアナザーワンピ',
            imgUrl      : '/images/items/NC-J5-59.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'LO',
            point       : 1600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-60',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムみかんアナザーシューズ',
            imgUrl      : '/images/items/NC-J5-60.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-J5-59',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-61',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムみかんアナザーヘアアクセ',
            imgUrl      : '/images/items/NC-J5-61.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-J5-59',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'PR',
          }),


          // [NOTE] ニコチケ SR
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-04',
            rare        : 'SR',
            name        : 'トゥインクルリボンスウィートパープルサイリウムワンピ',
            imgUrl      : '/images/items/NC-J5-04.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-05',
            rare        : 'SR',
            name        : 'トゥインクルリボンスウィートパープルサイリウムシューズ',
            imgUrl      : '/images/items/NC-J5-05.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-J5-04',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-06',
            rare        : 'SR',
            name        : 'トゥインクルリボンスウィートパープルサイリウムヘアアクセ',
            imgUrl      : '/images/items/NC-J5-06.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-J5-04',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-07',
            rare        : 'SR',
            name        : 'CAモアゆうやけサイリウムワンピ',
            imgUrl      : '/images/items/NC-J5-07.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-08',
            rare        : 'SR',
            name        : 'CAモアゆうやけサイリウムシューズ',
            imgUrl      : '/images/items/NC-J5-08.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-J5-07',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-09',
            rare        : 'SR',
            name        : 'CAモアゆうやけサイリウムヘアアクセ',
            imgUrl      : '/images/items/NC-J5-09.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-J5-07',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-62',
            rare        : 'SR',
            name        : 'ネオンドロップブラックサイリウムワンピ',
            imgUrl      : '/images/items/NC-J5-62.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-63',
            rare        : 'SR',
            name        : 'ネオンドロップブラックサイリウムシューズ',
            imgUrl      : '/images/items/NC-J5-63.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-J5-62',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-64',
            rare        : 'SR',
            name        : 'ネオンドロップブラックサイリウムヘアアクセ',
            imgUrl      : '/images/items/NC-J5-64.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-J5-62',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-65',
            rare        : 'SR',
            name        : 'プリズムストーンアンタレスサイリウムワンピ',
            imgUrl      : '/images/items/NC-J5-65.png',
            kind        : 'ワンピース',
            color       : '銀',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-66',
            rare        : 'SR',
            name        : 'プリズムストーンアンタレスサイリウムシューズ',
            imgUrl      : '/images/items/NC-J5-66.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 650,
            aggregation : 'NC-J5-65',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-67',
            rare        : 'SR',
            name        : 'プリズムストーンアンタレスサイリウムヘアアクセ',
            imgUrl      : '/images/items/NC-J5-67.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : '',
            type        : 'PR',
            point       : 650,
            aggregation : 'NC-J5-65',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'SR',
          }),


          // [NOTE] ニコチケ R
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-10',
            rare        : 'R',
            name        : 'おはないっぱいおしょうがつももいろトップス',
            imgUrl      : '/images/items/NC-J5-10.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-11',
            rare        : 'R',
            name        : 'おはないっぱいおしょうがつももいろスカート',
            imgUrl      : '/images/items/NC-J5-11.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-J5-10',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-12',
            rare        : 'R',
            name        : 'おはないっぱいおしょうがつももいろシューズ',
            imgUrl      : '/images/items/NC-J5-12.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-10',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-13',
            rare        : 'R',
            name        : 'おはないっぱいおしょうがつももいろヘアアクセ',
            imgUrl      : '/images/items/NC-J5-13.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-10',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-14',
            rare        : 'R',
            name        : 'アイスクリームおはないっぱいワンピ',
            imgUrl      : '/images/items/NC-J5-14.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1000,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-15',
            rare        : 'R',
            name        : 'アイスクリームおはないっぱいシューズ',
            imgUrl      : '/images/items/NC-J5-15.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-14',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-16',
            rare        : 'R',
            name        : 'アイスクリームおはないっぱいヘアアクセ',
            imgUrl      : '/images/items/NC-J5-16.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-14',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-68',
            rare        : 'R',
            name        : 'アイスクリームおはなだいだいワンピ',
            imgUrl      : '/images/items/NC-J5-68.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-69',
            rare        : 'R',
            name        : 'アイスクリームおはなだいだいシューズ',
            imgUrl      : '/images/items/NC-J5-69.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-68',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-70',
            rare        : 'R',
            name        : 'アイスクリームおはなだいだいヘアアクセ',
            imgUrl      : '/images/items/NC-J5-70.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-68',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-71',
            rare        : 'R',
            name        : 'アイスクリームおはなふじいろワンピ',
            imgUrl      : '/images/items/NC-J5-71.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-72',
            rare        : 'R',
            name        : 'アイスクリームおはなふじいろシューズ',
            imgUrl      : '/images/items/NC-J5-72.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-71',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-73',
            rare        : 'R',
            name        : 'アイスクリームおはなふじいろヘアアクセ',
            imgUrl      : '/images/items/NC-J5-73.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-71',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-17',
            rare        : 'R',
            name        : 'フラワーショップおはないっぱいトップス',
            imgUrl      : '/images/items/NC-J5-17.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 550,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-18',
            rare        : 'R',
            name        : 'フラワーショップおはないっぱいスカート',
            imgUrl      : '/images/items/NC-J5-18.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 600,
            aggregation : 'NC-J5-17',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-19',
            rare        : 'R',
            name        : 'フラワーショップおはないっぱいシューズ',
            imgUrl      : '/images/items/NC-J5-19.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-17',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-20',
            rare        : 'R',
            name        : 'フラワーショップおはないっぱいヘアアクセ',
            imgUrl      : '/images/items/NC-J5-20.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-17',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-21',
            rare        : 'R',
            name        : 'スターダストレザーブルートップス',
            imgUrl      : '/images/items/NC-J5-21.png',
            kind        : 'トップス',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-22',
            rare        : 'R',
            name        : 'スターダストレザーブルースカート',
            imgUrl      : '/images/items/NC-J5-22.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-J5-21',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-23',
            rare        : 'R',
            name        : 'スターダストレザーブルーシューズ',
            imgUrl      : '/images/items/NC-J5-23.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-21',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-24',
            rare        : 'R',
            name        : 'スターダストレザーブルーヘアアクセ',
            imgUrl      : '/images/items/NC-J5-24.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-21',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-25',
            rare        : 'R',
            name        : 'スターダストセーラーパープルトップス',
            imgUrl      : '/images/items/NC-J5-25.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-26',
            rare        : 'R',
            name        : 'スターダストセーラーパープルスカート',
            imgUrl      : '/images/items/NC-J5-26.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-J5-25',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-27',
            rare        : 'R',
            name        : 'スターダストセーラーパープルシューズ',
            imgUrl      : '/images/items/NC-J5-27.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-25',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-28',
            rare        : 'R',
            name        : 'スターダストセーラーパープルヘアアクセ',
            imgUrl      : '/images/items/NC-J5-28.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-25',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-29',
            rare        : 'R',
            name        : 'スターダストセーラーレッドトップス',
            imgUrl      : '/images/items/NC-J5-29.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-30',
            rare        : 'R',
            name        : 'スターダストセーラーレッドスカート',
            imgUrl      : '/images/items/NC-J5-30.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-J5-29',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-31',
            rare        : 'R',
            name        : 'スターダストセーラーレッドシューズ',
            imgUrl      : '/images/items/NC-J5-31.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-29',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-32',
            rare        : 'R',
            name        : 'スターダストセーラーレッドヘアアクセ',
            imgUrl      : '/images/items/NC-J5-32.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-29',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-33',
            rare        : 'R',
            name        : 'スターダストセーラーグリーントップス',
            imgUrl      : '/images/items/NC-J5-33.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-34',
            rare        : 'R',
            name        : 'スターダストセーラーグリーンスカート',
            imgUrl      : '/images/items/NC-J5-34.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-J5-33',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-35',
            rare        : 'R',
            name        : 'スターダストセーラーグリーンシューズ',
            imgUrl      : '/images/items/NC-J5-35.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-33',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-36',
            rare        : 'R',
            name        : 'スターダストセーラーグリーンヘアアクセ',
            imgUrl      : '/images/items/NC-J5-36.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-33',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-37',
            rare        : 'R',
            name        : 'キラキラフィーバースターダストトップス',
            imgUrl      : '/images/items/NC-J5-37.png',
            kind        : 'トップス',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-38',
            rare        : 'R',
            name        : 'キラキラフィーバースターダストスカート',
            imgUrl      : '/images/items/NC-J5-38.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-J5-37',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-39',
            rare        : 'R',
            name        : 'キラキラフィーバースターダストシューズ',
            imgUrl      : '/images/items/NC-J5-39.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-37',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-40',
            rare        : 'R',
            name        : 'キラキラフィーバースターダストヘアアクセ',
            imgUrl      : '/images/items/NC-J5-40.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-37',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-41',
            rare        : 'R',
            name        : 'バニーマジシャンワンピ',
            imgUrl      : '/images/items/NC-J5-41.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 1000,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-42',
            rare        : 'R',
            name        : 'バニーマジシャンシューズ',
            imgUrl      : '/images/items/NC-J5-42.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-41',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-43',
            rare        : 'R',
            name        : 'バニーマジシャンヘアアクセ',
            imgUrl      : '/images/items/NC-J5-43.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-41',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-44',
            rare        : 'R',
            name        : 'マドモアゼルマジシャンワンピ',
            imgUrl      : '/images/items/NC-J5-44.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 1000,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-45',
            rare        : 'R',
            name        : 'マドモアゼルマジシャンシューズ',
            imgUrl      : '/images/items/NC-J5-45.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-44',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-46',
            rare        : 'R',
            name        : 'マドモアゼルマジシャンヘアアクセ',
            imgUrl      : '/images/items/NC-J5-46.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-44',
          }),
          item({
            collection  : 'ニコチケ',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-47',
            rare        : 'R',
            name        : 'スマイルマジシャンネイビートップス',
            imgUrl      : '/images/items/NC-J5-47.png',
            kind        : 'トップス',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-48',
            rare        : 'R',
            name        : 'スマイルマジシャンネイビースカート',
            imgUrl      : '/images/items/NC-J5-48.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-J5-47',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-49',
            rare        : 'R',
            name        : 'スマイルマジシャンネイビーシューズ',
            imgUrl      : '/images/items/NC-J5-49.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-47',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-50',
            rare        : 'R',
            name        : 'スマイルマジシャンネイビーヘアアクセ',
            imgUrl      : '/images/items/NC-J5-50.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-47',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-51',
            rare        : 'R',
            name        : 'スマイルマジシャンロイヤルトップス',
            imgUrl      : '/images/items/NC-J5-51.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-52',
            rare        : 'R',
            name        : 'スマイルマジシャンロイヤルスカート',
            imgUrl      : '/images/items/NC-J5-52.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-J5-51',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-53',
            rare        : 'R',
            name        : 'スマイルマジシャンロイヤルシューズ',
            imgUrl      : '/images/items/NC-J5-53.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-51',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-54',
            rare        : 'R',
            name        : 'スマイルマジシャンロイヤルヘアアクセ',
            imgUrl      : '/images/items/NC-J5-54.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-51',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-55',
            rare        : 'R',
            name        : 'スマイルマジシャンブライトグリーントップス',
            imgUrl      : '/images/items/NC-J5-55.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-56',
            rare        : 'R',
            name        : 'スマイルマジシャンブライトグリーンスカート',
            imgUrl      : '/images/items/NC-J5-56.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : '',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-J5-55',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-57',
            rare        : 'R',
            name        : 'スマイルマジシャンブライトグリーンシューズ',
            imgUrl      : '/images/items/NC-J5-57.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-55',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-58',
            rare        : 'R',
            name        : 'スマイルマジシャンブライトグリーンヘアアクセ',
            imgUrl      : '/images/items/NC-J5-58.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-55',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-74',
            rare        : 'R',
            name        : 'クリームソーダトップス',
            imgUrl      : '/images/items/NC-J5-74.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-75',
            rare        : 'R',
            name        : 'クリームソーダスカート',
            imgUrl      : '/images/items/NC-J5-75.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-J5-74',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-76',
            rare        : 'R',
            name        : 'クリームソーダシューズ',
            imgUrl      : '/images/items/NC-J5-76.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-74',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-77',
            rare        : 'R',
            name        : 'クリームソーダヘアアクセ',
            imgUrl      : '/images/items/NC-J5-77.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-74',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-78',
            rare        : 'R',
            name        : 'レモンソーダトップス',
            imgUrl      : '/images/items/NC-J5-78.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-79',
            rare        : 'R',
            name        : 'レモンソーダスカート',
            imgUrl      : '/images/items/NC-J5-79.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-J5-78',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-80',
            rare        : 'R',
            name        : 'レモンソーダシューズ',
            imgUrl      : '/images/items/NC-J5-80.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-78',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-81',
            rare        : 'R',
            name        : 'レモンソーダヘアアクセ',
            imgUrl      : '/images/items/NC-J5-81.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-78',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-82',
            rare        : 'R',
            name        : 'ライムソーダトップス',
            imgUrl      : '/images/items/NC-J5-82.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-83',
            rare        : 'R',
            name        : 'ライムソーダスカート',
            imgUrl      : '/images/items/NC-J5-83.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-J5-82',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-84',
            rare        : 'R',
            name        : 'ライムソーダシューズ',
            imgUrl      : '/images/items/NC-J5-84.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-82',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-85',
            rare        : 'R',
            name        : 'ライムソーダヘアアクセ',
            imgUrl      : '/images/items/NC-J5-85.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-82',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-86',
            rare        : 'R',
            name        : 'グレープソーダトップス',
            imgUrl      : '/images/items/NC-J5-86.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-87',
            rare        : 'R',
            name        : 'グレープソーダスカート',
            imgUrl      : '/images/items/NC-J5-87.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-J5-86',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-88',
            rare        : 'R',
            name        : 'グレープソーダシューズ',
            imgUrl      : '/images/items/NC-J5-88.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-86',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-J5-89',
            rare        : 'R',
            name        : 'グレープソーダヘアアクセ',
            imgUrl      : '/images/items/NC-J5-89.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-86',
          }),


          // [NOTE] ニコチケ二択目 PR
          // ================================================================================

          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-90',
            rare        : 'PR',
            name        : 'ミラクルファンシーレインボードレス',
            imgUrl      : '/images/items/NC-J5-90.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1600,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-91',
            rare        : 'PR',
            name        : 'ミラクルファンシーレインボーシューズ',
            imgUrl      : '/images/items/NC-J5-91.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 800,
            aggregation : 'NC-J5-90',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'PR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'PR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-92',
            rare        : 'PR',
            name        : 'ナイトドリームドレス',
            imgUrl      : '/images/items/NC-J5-92.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 1600,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-93',
            rare        : 'PR',
            name        : 'ナイトドリームリボンシューズ',
            imgUrl      : '/images/items/NC-J5-93.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 800,
            aggregation : 'NC-J5-92',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'PR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'PR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-94',
            rare        : 'PR',
            name        : 'レインボーウエディング',
            imgUrl      : '/images/items/NC-J5-94.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 1600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-95',
            rare        : 'PR',
            name        : 'ミラクルレインボーブーツ',
            imgUrl      : '/images/items/NC-J5-95.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 800,
            aggregation : 'NC-J5-94',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'PR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'PR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-96',
            rare        : 'PR',
            name        : 'レディアントレインボードレス',
            imgUrl      : '/images/items/NC-J5-96.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1600,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-97',
            rare        : 'PR',
            name        : 'レインボーハイヒール',
            imgUrl      : '/images/items/NC-J5-97.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 800,
            aggregation : 'NC-J5-96',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-98',
            rare        : 'PR',
            name        : 'プリズムクイーンヘアアクセ',
            imgUrl      : '/images/items/NC-J5-98.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : '',
            type        : 'PR',
            point       : 800,
            aggregation : 'NC-J5-96',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'PR',
          }),


          // [NOTE] ニコチケ二択目 SR
          // ================================================================================

          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-99',
            rare        : 'SR',
            name        : 'セブンスコーデラブリードレスPc',
            imgUrl      : '/images/items/NC-J5-99.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-100',
            rare        : 'SR',
            name        : 'セブンスコーデラブリーシューズP',
            imgUrl      : '/images/items/NC-J5-100.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-J5-99',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-101',
            rare        : 'SR',
            name        : 'セブンスコーデポップドレスPc',
            imgUrl      : '/images/items/NC-J5-101.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-102',
            rare        : 'SR',
            name        : 'セブンスコーデポップシューズP',
            imgUrl      : '/images/items/NC-J5-102.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-J5-101',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-103',
            rare        : 'SR',
            name        : 'セブンスコーデクールドレスPc',
            imgUrl      : '/images/items/NC-J5-103.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-104',
            rare        : 'SR',
            name        : 'セブンスコーデクールシューズP',
            imgUrl      : '/images/items/NC-J5-104.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-J5-103',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),
           item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-105',
            rare        : 'SR',
            name        : 'セブンスコーデセクシードレスPc',
            imgUrl      : '/images/items/NC-J5-105.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-106',
            rare        : 'SR',
            name        : 'セブンスコーデセクシーシューズP',
            imgUrl      : '/images/items/NC-J5-106.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-J5-105',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-107',
            rare        : 'SR',
            name        : 'セブンスコーデフェミニンドレスPc',
            imgUrl      : '/images/items/NC-J5-107.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-108',
            rare        : 'SR',
            name        : 'セブンスコーデフェミニンシューズP',
            imgUrl      : '/images/items/NC-J5-108.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-J5-107',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-109',
            rare        : 'SR',
            name        : 'セブンスコーデエスニックドレスPc',
            imgUrl      : '/images/items/NC-J5-109.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-110',
            rare        : 'SR',
            name        : 'セブンスコーデエスニックシューズP',
            imgUrl      : '/images/items/NC-J5-110.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-J5-109',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-111',
            rare        : 'SR',
            name        : 'セブンスコーデスタードレスPc',
            imgUrl      : '/images/items/NC-J5-111.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-112',
            rare        : 'SR',
            name        : 'セブンスコーデスターシューズP',
            imgUrl      : '/images/items/NC-J5-112.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            aggregation : 'NC-J5-111',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-113',
            rare        : 'SR',
            name        : 'セブンスコーデラブリードレスB',
            imgUrl      : '/images/items/NC-J5-113.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-114',
            rare        : 'SR',
            name        : 'セブンスコーデラブリーシューズB',
            imgUrl      : '/images/items/NC-J5-114.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-J5-113',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-115',
            rare        : 'SR',
            name        : 'セブンスコーデポップドレスB',
            imgUrl      : '/images/items/NC-J5-115.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-116',
            rare        : 'SR',
            name        : 'セブンスコーデポップシューズB',
            imgUrl      : '/images/items/NC-J5-116.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-J5-115',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-117',
            rare        : 'SR',
            name        : 'セブンスコーデクールドレスB',
            imgUrl      : '/images/items/NC-J5-117.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-118',
            rare        : 'SR',
            name        : 'セブンスコーデクールシューズB',
            imgUrl      : '/images/items/NC-J5-118.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-J5-117',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-119',
            rare        : 'SR',
            name        : 'セブンスコーデセクシードレスB',
            imgUrl      : '/images/items/NC-J5-119.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-120',
            rare        : 'SR',
            name        : 'セブンスコーデセクシーシューズB',
            imgUrl      : '/images/items/NC-J5-120.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-J5-119',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-121',
            rare        : 'SR',
            name        : 'セブンスコーデフェミニンドレスB',
            imgUrl      : '/images/items/NC-J5-121.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-122',
            rare        : 'SR',
            name        : 'セブンスコーデフェミニンシューズB',
            imgUrl      : '/images/items/NC-J5-122.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-J5-121',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-123',
            rare        : 'SR',
            name        : 'セブンスコーデエスニックドレスB',
            imgUrl      : '/images/items/NC-J5-123.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-124',
            rare        : 'SR',
            name        : 'セブンスコーデエスニックシューズB',
            imgUrl      : '/images/items/NC-J5-124.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-J5-123',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-125',
            rare        : 'SR',
            name        : 'セブンスコーデスタードレスB',
            imgUrl      : '/images/items/NC-J5-125.png',
            kind        : 'ワンピース',
            color       : '銀',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-126',
            rare        : 'SR',
            name        : 'セブンスコーデスターシューズB',
            imgUrl      : '/images/items/NC-J5-126.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            aggregation : 'NC-J5-125',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'SR',
          }),


          // [NOTE] ニコチケ二択目 R
          // ================================================================================

          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-127',
            rare        : 'R',
            name        : 'ドリーミングハーモニージャケット',
            imgUrl      : '/images/items/NC-J5-127.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-128',
            rare        : 'R',
            name        : 'ドリーミングハーモニースカート',
            imgUrl      : '/images/items/NC-J5-128.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-J5-127',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-129',
            rare        : 'R',
            name        : 'ミュージックテクニカルブーツ',
            imgUrl      : '/images/items/NC-J5-129.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-J5-127',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-130',
            rare        : 'R',
            name        : 'スカイメロディジャケット',
            imgUrl      : '/images/items/NC-J5-130.png',
            kind        : 'トップス',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-131',
            rare        : 'R',
            name        : 'スカイメロディショーパン',
            imgUrl      : '/images/items/NC-J5-131.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-J5-130',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-132',
            rare        : 'R',
            name        : 'ミュージックテクニカルブーツ',
            imgUrl      : '/images/items/NC-J5-129.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-J5-130',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-133',
            rare        : 'R',
            name        : 'バイオレットノクターンジャケット',
            imgUrl      : '/images/items/NC-J5-133.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-134',
            rare        : 'R',
            name        : 'バイオレットノクターンスカート',
            imgUrl      : '/images/items/NC-J5-134.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-J5-133',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-135',
            rare        : 'R',
            name        : 'ミュージックテクニカルブーツ',
            imgUrl      : '/images/items/NC-J5-129.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-J5-133',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-136',
            rare        : 'R',
            name        : 'ベルローズワインレッドベアトップ',
            imgUrl      : '/images/items/NC-J5-136.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-137',
            rare        : 'R',
            name        : 'ベルローズワインレッドタイトミニ',
            imgUrl      : '/images/items/NC-J5-137.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-J5-136',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-138',
            rare        : 'R',
            name        : 'レッドリボンニーハイ&パンプス',
            imgUrl      : '/images/items/NC-J5-138.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-J5-136',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-139',
            rare        : 'R',
            name        : 'ベルローズシルキーイエローベアトップ',
            imgUrl      : '/images/items/NC-J5-139.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-140',
            rare        : 'R',
            name        : 'ベルローズシルキーイエローパニエ',
            imgUrl      : '/images/items/NC-J5-140.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-J5-139',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-141',
            rare        : 'R',
            name        : 'ブラックリボンパンプス',
            imgUrl      : '/images/items/NC-J5-141.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-J5-139',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-142',
            rare        : 'R',
            name        : 'ベルローズスパークグリーンベアトップ',
            imgUrl      : '/images/items/NC-J5-142.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-143',
            rare        : 'R',
            name        : 'ベルローズスパークグリーンパンツ',
            imgUrl      : '/images/items/NC-J5-143.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-J5-142',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-144',
            rare        : 'R',
            name        : 'ブラックリボンパンプス',
            imgUrl      : '/images/items/NC-J5-144.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-J5-142',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-145',
            rare        : 'R',
            name        : 'ハッピーレイン♪キュートセーラー',
            imgUrl      : '/images/items/NC-J5-145.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-146',
            rare        : 'R',
            name        : 'ハッピーレイン♪キューティーパニエ',
            imgUrl      : '/images/items/NC-J5-146.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-J5-145',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-147',
            rare        : 'R',
            name        : 'ハッピーレイン♪キュートブーツ',
            imgUrl      : '/images/items/NC-J5-147.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-J5-145',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-148',
            rare        : 'R',
            name        : 'プリティーオールフレンズハッピーレイン♪ヘアアクセ',
            imgUrl      : '/images/items/NC-J5-148.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-145',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-149',
            rare        : 'R',
            name        : 'ハッピーレイン♪アクアセーラー',
            imgUrl      : '/images/items/NC-J5-149.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-150',
            rare        : 'R',
            name        : 'ハッピーレイン♪アクアショーパン',
            imgUrl      : '/images/items/NC-J5-150.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-J5-149',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-151',
            rare        : 'R',
            name        : 'ハッピーレイン♪キュートブーツ',
            imgUrl      : '/images/items/NC-J5-151.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-J5-149',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-152',
            rare        : 'R',
            name        : 'プリティーオールフレンズハッピーレイン♪ヘアアクセ',
            imgUrl      : '/images/items/NC-J5-152.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-149',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-153',
            rare        : 'R',
            name        : 'ハッピーレイン♪ベリーセーラー',
            imgUrl      : '/images/items/NC-J5-153.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-154',
            rare        : 'R',
            name        : 'ハッピーレイン♪ベリーパンツ',
            imgUrl      : '/images/items/NC-J5-154.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-J5-153',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-155',
            rare        : 'R',
            name        : 'ハッピーレイン♪キュートブーツ',
            imgUrl      : '/images/items/NC-J5-155.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-J5-153',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-156',
            rare        : 'R',
            name        : 'プリティーオールフレンズハッピーレイン♪ヘアアクセ',
            imgUrl      : '/images/items/NC-J5-156.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-153',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-157',
            rare        : 'R',
            name        : 'イノセントトゥルーラブワンピ',
            imgUrl      : '/images/items/NC-J5-157.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 1000,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-158',
            rare        : 'R',
            name        : 'イノセントソックス&パンプス',
            imgUrl      : '/images/items/NC-J5-158.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-J5-157',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-159',
            rare        : 'R',
            name        : 'イノセントフレンドシップワンピ',
            imgUrl      : '/images/items/NC-J5-159.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 1000,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-160',
            rare        : 'R',
            name        : 'イノセントミラクルブーツ',
            imgUrl      : '/images/items/NC-J5-160.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-J5-159',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-161',
            rare        : 'R',
            name        : 'イノセントホープフリルキャミ',
            imgUrl      : '/images/items/NC-J5-161.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-162',
            rare        : 'R',
            name        : 'イノセントホープショーパン',
            imgUrl      : '/images/items/NC-J5-162.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-J5-161',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-163',
            rare        : 'R',
            name        : 'イノセントミラクルブーツ',
            imgUrl      : '/images/items/NC-J5-163.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-J5-161',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-164',
            rare        : 'R',
            name        : 'ハピなるアヒルちゃんワンピ',
            imgUrl      : '/images/items/NC-J5-164.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1000,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-165',
            rare        : 'R',
            name        : 'ハピなるアヒルちゃんシューズ',
            imgUrl      : '/images/items/NC-J5-165.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-164',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-166',
            rare        : 'R',
            name        : 'ビューティフルフェザーワンピ',
            imgUrl      : '/images/items/NC-J5-166.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 1000,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-167',
            rare        : 'R',
            name        : 'ビューティフルフェザーパンプス',
            imgUrl      : '/images/items/NC-J5-167.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-166',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-168',
            rare        : 'R',
            name        : 'コズミックアシメトップス',
            imgUrl      : '/images/items/NC-J5-168.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-169',
            rare        : 'R',
            name        : 'コズミックスペーススカート',
            imgUrl      : '/images/items/NC-J5-169.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 550,
            aggregation : 'NC-J5-168',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-170',
            rare        : 'R',
            name        : 'コズミックアシメブーツ',
            imgUrl      : '/images/items/NC-J5-170.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-J5-168',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-171',
            rare        : 'R',
            name        : 'コズミックチャイナトップス',
            imgUrl      : '/images/items/NC-J5-171.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-172',
            rare        : 'R',
            name        : 'コズミックスターショーパン',
            imgUrl      : '/images/items/NC-J5-172.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 550,
            aggregation : 'NC-J5-171',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-173',
            rare        : 'R',
            name        : 'コズミックタイツ&パンプス',
            imgUrl      : '/images/items/NC-J5-173.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PO',
            point       : 500,
            aggregation : 'NC-J5-171',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-174',
            rare        : 'R',
            name        : 'ロイヤルマニッシュジャケット',
            imgUrl      : '/images/items/NC-J5-174.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-175',
            rare        : 'R',
            name        : 'ロイヤルマニッシュスマートパンツ',
            imgUrl      : '/images/items/NC-J5-175.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-J5-174',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-176',
            rare        : 'R',
            name        : 'ロイヤルスラッシュパンプス',
            imgUrl      : '/images/items/NC-J5-176.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-J5-174',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-177',
            rare        : 'R',
            name        : 'ロイヤルメルヘンプリンセスドレス',
            imgUrl      : '/images/items/NC-J5-177.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 1000,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-178',
            rare        : 'R',
            name        : 'ロイヤルメルヘンシューズ',
            imgUrl      : '/images/items/NC-J5-178.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-J5-177',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-179',
            rare        : 'R',
            name        : 'ダンシングクイーンワンピ',
            imgUrl      : '/images/items/NC-J5-179.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 1000,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-180',
            rare        : 'R',
            name        : 'ダンシングクイーンシューズ',
            imgUrl      : '/images/items/NC-J5-180.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-J5-179',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'R',
          }),


          // [NOTE] ニコチケ二択目 N
          // ================================================================================

          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-181',
            rare        : 'N',
            name        : 'ギンガムパフスリーブ',
            imgUrl      : '/images/items/NC-J5-181.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 450,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-182',
            rare        : 'N',
            name        : 'シャーベットドットキュロット',
            imgUrl      : '/images/items/NC-J5-182.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 400,
            aggregation : 'NC-J5-181',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-183',
            rare        : 'N',
            name        : 'シャーベットパンプス',
            imgUrl      : '/images/items/NC-J5-183.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 350,
            aggregation : 'NC-J5-181',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'N',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-184',
            rare        : 'N',
            name        : 'ネオンボーダーTシャツ',
            imgUrl      : '/images/items/NC-J5-184.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 450,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-185',
            rare        : 'N',
            name        : 'ロックチェックスカート',
            imgUrl      : '/images/items/NC-J5-185.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 400,
            aggregation : 'NC-J5-184',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-186',
            rare        : 'N',
            name        : 'ブルーパンクミドルブーツ',
            imgUrl      : '/images/items/NC-J5-186.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 350,
            aggregation : 'NC-J5-184',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'N',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-187',
            rare        : 'N',
            name        : 'ウォッシュデニムシャツ',
            imgUrl      : '/images/items/NC-J5-187.png',
            kind        : 'トップス',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 450,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-188',
            rare        : 'N',
            name        : 'ほそみストライプグラデパンツ',
            imgUrl      : '/images/items/NC-J5-188.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 400,
            aggregation : 'NC-J5-187',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-189',
            rare        : 'N',
            name        : 'ラインモノトーンサンダル',
            imgUrl      : '/images/items/NC-J5-189.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 350,
            aggregation : 'NC-J5-187',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'N',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-190',
            rare        : 'N',
            name        : 'ローズレッドチェックワンピ',
            imgUrl      : '/images/items/NC-J5-190.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 700,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-191',
            rare        : 'N',
            name        : 'モノクロリボンレッドパンプス',
            imgUrl      : '/images/items/NC-J5-191.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 350,
            aggregation : 'NC-J5-190',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'N',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'N',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-192',
            rare        : 'N',
            name        : 'ローズかただしトップス',
            imgUrl      : '/images/items/NC-J5-192.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 450,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-193',
            rare        : 'N',
            name        : 'ローズステッチフレアパンツ',
            imgUrl      : '/images/items/NC-J5-193.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 400,
            aggregation : 'NC-J5-192',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-194',
            rare        : 'N',
            name        : 'ウェッジヒールビーサン',
            imgUrl      : '/images/items/NC-J5-194.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : '',
            type        : 'PO',
            point       : 350,
            aggregation : 'NC-J5-192',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'N',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-195',
            rare        : 'N',
            name        : 'かただしふんわりニット',
            imgUrl      : '/images/items/NC-J5-195.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 450,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-196',
            rare        : 'N',
            name        : 'パステルブルーフリルスカート',
            imgUrl      : '/images/items/NC-J5-196.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 400,
            aggregation : 'NC-J5-195',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-197',
            rare        : 'N',
            name        : 'カサブランカサンダル',
            imgUrl      : '/images/items/NC-J5-197.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 350,
            aggregation : 'NC-J5-195',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'N',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-198',
            rare        : 'N',
            name        : 'プリズムスクールパステルニット',
            imgUrl      : '/images/items/NC-J5-198.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 450,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-199',
            rare        : 'N',
            name        : 'プリズムスクールブルースカート',
            imgUrl      : '/images/items/NC-J5-199.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 400,
            aggregation : 'NC-J5-198',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-200',
            rare        : 'N',
            name        : 'プリズムスクールローファー',
            imgUrl      : '/images/items/NC-J5-200.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : '',
            type        : 'PR',
            point       : 350,
            aggregation : 'NC-J5-198',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'N',
          }),


          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-201',
            rare        : 'N',
            name        : 'ル・セリアナゴージャスジャケット',
            imgUrl      : '/images/items/NC-J5-201.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 450,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-202',
            rare        : 'N',
            name        : 'ル・セリアナゴージャススカート',
            imgUrl      : '/images/items/NC-J5-202.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 400,
            aggregation : 'NC-J5-201',
          }),
          item({
            collection  : 'ニコチケ二択目',
            id          : 'NC-J5-203',
            rare        : 'N',
            name        : 'ル・セリアナローファー',
            imgUrl      : '/images/items/NC-J5-203.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 350,
            aggregation : 'NC-J5-201',
          }),
          item({
            collection  : 'ニコチケ二択目',
            rare        : 'N',
          }),


          // [NOTE] スペシャルキラニコチケキャンペーン
          // ================================================================================

          externalItem(itemsPromo2019Events, 'P-NC-003'  , { collection: 'SpKiraNico' }),
          externalItem(itemsPromo2019Events, 'P-NC-003-S', { collection: 'SpKiraNico' }),
          externalItem(itemsPromo2019Events, 'P-NC-003-H', { collection: 'SpKiraNico' }),
          item({
            collection  : 'SpKiraNico',
            rare        : 'PR',
          }),


        ],
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },

      itemsJR8 () {
        return _.where(this.itemsMaJor, { rare: 'JR', collection: 'あんなコレクション' })
      },

      itemsJR9 () {
        return _.where(this.itemsMaJor, { rare: 'JR', collection: 'だいあコレクション' })
      },

      itemsRR () {
        return _.where(this.itemsMaJor, { rare: 'RR' })
      },

      itemsHR () {
        return _.where(this.itemsMaJor, { rare: 'HR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, { rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, { rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, { rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, { rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' }).filter(item => this.major.includes(item.collection) )
      },

      itemsBrandRank () {
        return _.where(this.itemsFiltered, { collection: 'ブランドランク' })
      },

      itemsPBox () {
        return _.where(this.itemsFiltered, { collection: 'プレゼントボックス' })
      },

      itemsJewelPact () {
        return _.where(this.itemsFiltered, { collection: 'ジュエルパクト' })
      },

      itemsDesignPalette () {
        return _.where(this.itemsFiltered, { collection: 'デザインパレット自作' })
      },

      itemsMolly () {
        return _.where(this.itemsFiltered, { collection: 'モーリーファンタジー限定' })
      },

      itemsFMChannel () {
        return _.where(this.itemsFiltered, { collection: 'ファントミラージュチャンネル' })
      },

      itemsSGChannel () {
        return _.where(this.itemsFiltered, { collection: 'すみっコぐらしチャンネル' })
      },

      itemsXmasChannel () {
        return _.where(this.itemsFiltered, { collection: 'クリスマスチャンネル' })
      },

      itemsNewYearChannel () {
        return _.where(this.itemsFiltered, { collection: 'おしょうがつチャンネル' })
      },

      itemsPAF () {
        return _.where(this.itemsFiltered, { collection: 'プリティーオールフレンズチャンネル' })
      },

      itemsWinterScratch () {
        return _.where(this.itemsFiltered, { collection: 'ウィンタースクラッチ' })
      },

      itemsCGCSpecial () {
        return _.where(this.itemsFiltered, { collection: 'CGCSpecial' })
      },

      itemsLuckyBag1 () {
        return _.where(this.itemsFiltered, { collection: '冬休み福袋その1' })
      },

      itemsLuckyBag1PR () {
        return _.where(this.itemsLuckyBag1, { rare: 'PR' })
      },

      itemsLuckyBag1SR () {
        return _.where(this.itemsLuckyBag1, { rare: 'SR' })
      },

      itemsLuckyBag2 () {
        return _.where(this.itemsFiltered, { collection: '冬休み福袋その2' })
      },

      itemsLuckyBag2PR () {
        return _.where(this.itemsLuckyBag2, { rare: 'PR' })
      },

      itemsLuckyBag2SR () {
        return _.where(this.itemsLuckyBag2, { rare: 'SR' })
      },

      itemsNico () {
        return _.where(this.itemsFiltered, { collection: 'ニコチケ' })
      },

      itemsNicoPR () {
        return _.where(this.itemsNico, { rare: 'PR' })
      },

      itemsNicoSR () {
        return _.where(this.itemsNico, { rare: 'SR' })
      },

      itemsNicoR () {
        return _.where(this.itemsNico, { rare: 'R' })
      },

      itemsNicoN () {
        return _.where(this.itemsNico, { rare: 'N' })
      },

      itemsNico2 () {
        return _.where(this.itemsFiltered, { collection: 'ニコチケ二択目' })
      },

      itemsNico2PR () {
        return _.where(this.itemsNico2, { rare: 'PR' })
      },

      itemsNico2SR () {
        return _.where(this.itemsNico2, { rare: 'SR' })
      },

      itemsNico2R () {
        return _.where(this.itemsNico2, { rare: 'R' })
      },

      itemsNico2N () {
        return _.where(this.itemsNico2, { rare: 'N' })
      },

      itemsSpKiraNico () {
        return _.where(this.itemsFiltered, { collection: 'SpKiraNico' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1,2,12,13,15]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="JR ◆◆◆◆" color="#44cd1f" :items="itemsJR8" />
    </template>

    <template #col2>
      <ItemList title="JR ◆◆◆◆" color="#44cd1f" :items="itemsJR9" />
    </template>

    <template #col3>
      <ItemList title="RR ◆◆◆◆" color="#edd50f" :items="itemsRR | first(12)" />
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR | first(16)" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR | first(12)" />
    </template>

    <template #col4>
      <ItemList title="RR ◆◆◆◆" color="#edd50f" :items="itemsRR | rest(12)" />
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR | rest(16)" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR | rest(12)" />
      <ItemList title="PR モーリー限定 ★★★" color="#55b272" :items="itemsMolly" />
    </template>

    <template #col5>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
    </template>

    <template #col6>
      <ItemList title="ブランドランク" color="#c598ff" :items="itemsBrandRank" />
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
      <ItemList title="ウィンタースクラッチ" color="#c598ff" :items="itemsWinterScratch" />
      <ItemList title="ジュエルパクト" color="#c598ff" :items="itemsJewelPact" />
      <ItemList title="デザインパレット自作" color="#c598ff" :items="itemsDesignPalette" />
      <ItemList title="クーリッシュグレーコーデ|スペシャルキャンペーン" color="#a1c0fa" :items="itemsCGCSpecial" />
    </template>

    <template #col7>
      <ItemList title="ファントミラージュチャンネル" color="#a1c0fa" :items="itemsFMChannel" />
      <ItemList title="すみっコぐらしチャンネル" color="#a1c0fa" :items="itemsSGChannel | first(4)" />
      <!-- <ItemList title="すみっコぐらし（再録分）" color="#a1c0fa" :items="itemsSGChannel | rest(4)" /> -->
      <ItemList title="クリスマスチャンネル" color="#a1c0fa" :items="itemsXmasChannel" />
      <ItemList title="おしょうがつチャンネル" color="#a1c0fa" :items="itemsNewYearChannel" />
      <ItemList title="プリティーオールフレンズチャンネル" color="#a1c0fa" :items="itemsPAF" />
    </template>

    <template #col8>
      <ItemList title="冬休み福袋その1 PR ★★★" color="#ffa1bc" :items="itemsLuckyBag1PR" />
      <ItemList title="冬休み福袋その1 SR ★★" color="#00c7da" :items="itemsLuckyBag1SR" />
    </template>

    <template #col9>
      <ItemList title="冬休み福袋その2 PR ★★★" color="#ffa1bc" :items="itemsLuckyBag2PR" />
      <ItemList title="冬休み福袋その2 SR ★★" color="#00c7da" :items="itemsLuckyBag2SR" />
    </template>

    <template #col10>
      <ItemList title="ニコチケ PR ★★★" color="#ffa1bc" :items="itemsNicoPR" />
      <ItemList title="ニコチケ SR ★★" color="#00c7da" :items="itemsNicoSR" />
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | first(6 * 4)" />
    </template>

    <template #col11>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | rest(6 * 4)" :isOrphan="true" />
    </template>

    <template #col12>
      <ItemList title="ニコチケ二択目 PR ★★★" color="#ffa1bc" :items="itemsNico2PR" />
      <ItemList title="ニコチケ二択目 SR ★★" color="#00c7da" :items="itemsNico2SR | first(7 * 4)" />
    </template>

    <template #col13>
      <ItemList title="ニコチケ二択目 SR ★★" color="#00c7da" :items="itemsNico2SR | rest(7 * 4)" :isOrphan="true" />
      <ItemList title="ニコチケ二択目 R ★" color="#feab0d" :items="itemsNico2R | first(6 * 4)" />
    </template>

    <template #col14>
      <ItemList title="ニコチケ二択目 R ★" color="#feab0d" :items="itemsNico2R | rest(6 * 4)" :isOrphan="true" />
    </template>

    <template #col15>
      <ItemList title="ニコチケ二択目 N" color="#f6c3b2" :items="itemsNico2N" />
      <ItemList title="スペシャルキラニコチケ|PR ★★★" color="#ffa1bc" :items="itemsSpKiraNico" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" :showHR="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // コレクショングループ間の間隔 (SR)
  .Page ::v-deep .Page__col:nth-child(5) .ItemList:nth-child(1) {
    .Item:nth-child(5),
    .Item:nth-child(6),
    .Item:nth-child(7),
    .Item:nth-child(8),
    .Item:nth-child(9),
    .Item:nth-child(10),
    .Item:nth-child(11),
    .Item:nth-child(12) {
      margin-top: $size-unit * 8;
    }
  }

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
